import { getElementToSkipFocusTo } from "keyboardNavigation/utils";
import moment from "moment";
import React from "react";
import { DayPicker } from "react-day-picker";
import { momentToTzDate, timeZone } from "./DatePickerBase";
import getConfiguredLocale from "./getConfiguredLocale";

interface DisplayOnlyCalendarProps {
  startDate: moment.Moment;
  monthsToShow: number;
  selectedDates: moment.Moment[];
}

export const DisplayOnlyCalendar = (props: DisplayOnlyCalendarProps) => {
  const isDayDisabled = (date: Date): boolean => {
    const m = moment.utc(date);
    return m.isBefore(props.startDate);
  }

  return <div className="flex gap" style={{ flexWrap: "wrap" }}>
    <DayPicker
      numberOfMonths={props.monthsToShow}
      hideNavigation
      selected={props.selectedDates.map(momentToTzDate)}
      onSelect={() => { }}
      timeZone={timeZone}
      disabled={isDayDisabled}
      locale={getConfiguredLocale(serverReference.culture.uiLocale)}
      month={momentToTzDate(props.startDate)}
      fixedWeeks
      formatters={{
        formatWeekdayName: (date) => serverReference.abbreviatedDayLetters[date.getDay()]
      }}
      // Skip focus on days
      onDayFocus={(_, __, e) => {
        const skipTo = getElementToSkipFocusTo("rdp-day_button", e.relatedTarget as HTMLElement);
        skipTo?.focus();
      }}
      mode="multiple"
    />
  </div>
}